module.exports = __webpack_public_path__ + "img/undraw_teaching_f1cm.e2b658f2.svg";